var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    viewBox: "0 0 232 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 116,
    r: 109.04,
    fill: "#161523",
    stroke: "#6764FB",
    strokeWidth: 13.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.4 74.2401C162.4 71.6775 160.322 69.6002 157.76 69.6002L87.9882 69.6001C84.9393 69.6001 82.2716 70.0423 79.9849 70.9268C77.6983 71.8793 75.7927 73.1379 74.2683 74.7027C72.6803 76.3356 71.5053 78.1725 70.7431 80.2136C69.9808 82.3227 69.5997 84.4998 69.5997 86.745V97.029C69.5997 102.381 73.9386 106.72 79.2909 106.72H134.56L106.72 88.1601H157.76C160.322 88.1601 162.4 86.0827 162.4 83.5201V74.2401ZM69.5996 157.76C69.5996 160.323 71.677 162.4 74.2396 162.4L144.011 162.4C147.06 162.4 149.728 161.958 152.014 161.073C154.301 160.121 156.207 158.862 157.731 157.297C159.319 155.665 160.494 153.828 161.256 151.787C162.018 149.677 162.4 147.5 162.4 145.255V134.971C162.4 129.619 158.061 125.28 152.708 125.28H97.4396L125.28 143.84H74.2396C71.677 143.84 69.5996 145.917 69.5996 148.48V157.76Z",
    fill: "#6764FB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColor);
export default __webpack_public_path__ + "static/media/IconColor.ed879c6bf031b7f25ab2b989106b3524.svg";
export { ForwardRef as ReactComponent };